import { useMemo } from 'react';
import { useUser } from '@sezenta/connection';

// CR004 — read the current user's effective permissions for the ACTIVE contract
// (the token is already scoped to it). A platform super-admin passes every check.
// Use this to hide UI the user can't act on; the backend guard is the real gate.
export const usePermissions = () => {
  const user = useUser() as
    | { permissions?: string[]; isSuperAdmin?: boolean }
    | null
    | undefined;

  const isSuperAdmin = user?.isSuperAdmin === true;

  const set = useMemo(
    () => new Set<string>(user?.permissions ?? []),
    [user?.permissions],
  );
  const permissions = user?.permissions ?? [];

  const has = (p: string): boolean => isSuperAdmin || set.has(p);
  const hasAny = (ps: string[]): boolean =>
    isSuperAdmin || ps.some((p) => set.has(p));
  const hasAll = (ps: string[]): boolean =>
    isSuperAdmin || ps.every((p) => set.has(p));

  return { has, hasAny, hasAll, isSuperAdmin, permissions };
};
